// extracted by mini-css-extract-plugin
export var body = "_fh-0";
export var sectionHeader = "_fh-4";
export var shortcutColumns = "_fh-2";
export var shortcutList = "_fh-1";
export var shortcutSection = "_fh-3";